import { Heading, useBreakpoint } from "@seneca/senekit";

export default function LoginHeader({
  headerMessage
}: {
  headerMessage?: string;
}) {
  const { isMobileOnly } = useBreakpoint();
  return (
    <Heading level={isMobileOnly ? "4" : "3"} align={["left", "center"]}>
      {headerMessage ?? "Log in"}
    </Heading>
  );
}
